import React from 'react';

import { Typography } from 'antd';
// eslint-disable-next-line import/no-unresolved
import EasyVirtualizedScroller from 'easy-react-virtualized';

import AnalyticsEventsAPI from '../../api/AnalyticsEventsAPI';
import Loader from '../../components/Loader';
import { useAppSelector } from '../../shared/hooks';
import { dynamicItemTitle } from '../../shared/utils';
import { IWebinar } from '../../types/feedTypes';
import NoDataFound from '../Feed/components/NoDataFound/NoDataFound';
import VideoCallCard from '../Feed/VideoCall/VideoCallCard/VideoCallCard';

interface Props {
  refreshing: boolean;
  onRefreshed: () => void;
  hasMore?: boolean;
  loading?: boolean;
  webinarType: 'upcoming' | 'completed';
  webinars: IWebinar[];
  onJoinBtnClick?: (data: IWebinar) => void;
  getMoreWebinars: () => Promise<void>;
  onMenuPress?: (data: IWebinar) => void;
  onPostButtonPress?: (data: IWebinar) => void;
  onDetailsPress?: (data: IWebinar) => void;
}

const WorkshopFlatlist: React.FunctionComponent<Props> = ({
  loading,
  hasMore,
  webinarType,
  webinars,
  getMoreWebinars,
  onMenuPress,
  onDetailsPress,
  onJoinBtnClick,
}) => {
  const {
    isTagMango,
    hostMetadata: { appName },
    titleConfig,
  } = useAppSelector((state) => state.app);
  const userDetails = useAppSelector((state) => state.user);

  const conditionfordownload = (webinar: IWebinar) => {
    const recordings = [
      ...(webinar?.zoomRecordingDetails || []),
      ...(webinar?.hmsRecordingUrlArr || []),
      ...(webinar?.zoomRecordingUrlArr || []),
      ...(webinar?.zoomRecordingUrlS3Arr || []),
    ];
    if (
      (userDetails.type === 'creator_completed' ||
        userDetails.type === 'dual') &&
      webinar?.videocallType === 'webinar' &&
      webinar?.status === 'completed' &&
      webinar?.creator === userDetails.id &&
      recordings.length > 0
    ) {
      return true;
    }
    return false;
  };

  return (
    <div className="scroll-element workshops__content">
      <EasyVirtualizedScroller
        onLoadMore={() => getMoreWebinars()}
        useParentScrollElement={true}
        hasMore={hasMore}>
        {webinars.map((item, index) => (
          <div style={{ marginBottom: 12 }}>
            <VideoCallCard
              key={item._id}
              data={item}
              webinarType={webinarType}
              host={{
                ...item.creatorDetails,
                name: isTagMango ? item.creatorDetails.name : appName,
              }}
              // host={
              //   item.participants.find((el: any) => el._id === item.creator) ||
              //   item.participants[0]
              // }
              onMenuClick={
                webinarType === 'completed' &&
                !conditionfordownload(webinars[index])
                  ? undefined
                  : onMenuPress
                    ? () => {
                        onMenuPress(item);

                        // track workshop card click event
                        AnalyticsEventsAPI.trackWorkshopEvents(
                          'WORKSHOP_CLICKED',
                          {
                            meetingId: item._id,
                            date: new Date().toISOString(),
                            title: item.title,
                            platform: item.platform,
                            callType: item.callType,
                            createdAt: item.createdAt,
                            fromTime: item.fromTime,
                            toTime: item.toTime,
                            description: item.description,
                            mango: item.mango,
                            excludeMangoes: item.excludeMangoes,
                            mangoToSell: item.mangoToSell,
                          },
                        );
                      }
                    : undefined
              }
              onSelect={() => {
                if (onDetailsPress) onDetailsPress(item);
              }}
              onJoinBtnClick={() => {
                if (onJoinBtnClick) {
                  onJoinBtnClick(item);
                }
              }}
            />
          </div>
        ))}
      </EasyVirtualizedScroller>
      {loading === true || hasMore === true ? (
        <div
          style={{
            marginTop: 12,
            textAlign: 'center',
          }}>
          <Loader />
        </div>
      ) : webinars.length === 0 ? (
        <NoDataFound
          title={`Oops! No ${dynamicItemTitle('workshops')} found!`}
          subtitle={
            webinarType === 'upcoming'
              ? `Looks like there are no ${dynamicItemTitle('workshops')} yet! 🙌`
              : `Looks like no ${dynamicItemTitle('workshops')} have been set-up so far!`
          }
        />
      ) : (
        <Typography.Paragraph
          style={{
            width: '100%',
            textAlign: 'center',
            marginBlock: '20px 85px',
          }}>
          That’s it! No more {titleConfig.workshops} to show.
        </Typography.Paragraph>
      )}
    </div>
  );
};

export default React.memo(WorkshopFlatlist);
